import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// @TODO: Eslint rule 어김 제거
/* eslint-disable import/no-internal-modules */
/* eslint-disable boundaries/element-types */
import * as InputContainer from '@_widgets/user/InputContainer';
import { userApi } from '@_entities/user';

import { useHTMLParse } from '@_shared/hooks';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

import * as S from './NicknameSlide.style';

export function NicknameSlide({
	onNext,
	setNickname: setResultDataNickname,
}: {
	onNext: () => void;
	setNickname: (nickname: string) => void;
}) {
	const [searchParams] = useSearchParams();

	const [inputNickname, setNickname] = useState<string>(
		searchParams.get('nickname') !== null ? (searchParams.get('nickname') as string) : '',
	);
	const [message, setMessage] = useState<string>();

	const parsedMessage = useHTMLParse(message ?? '');

	return (
		<S.SlideContainer>
			<S.TermsSlide>
				<Typography type="headline-small" color="font-primary">
					딸깍에서 사용할 <br />
					닉네임을 정해주세요 :)
				</Typography>

				<InputContainer.Container>
					<Typography type="title-small" color="font-tertiary">
						닉네임
					</Typography>
					<InputContainer.Input
						type="text"
						defaultValue={inputNickname}
						maxLength={15}
						borderColor={message ? 'red-primary' : 'warmgray-200'}
						minLength={2}
						onInput={(e) => {
							const spaceRegex = /\s/;
							if (spaceRegex.exec(e.currentTarget.value)) {
								e.currentTarget.focus();
								e.currentTarget.value = e.currentTarget.value.replace(/\s| /gi, '');
							}

							setNickname(e.currentTarget.value);
						}}
					>
						<S.InputLength>
							<Typography type="label-medium" color="warmgray-400">
								{inputNickname.length}
								/15
							</Typography>
						</S.InputLength>
					</InputContainer.Input>

					<InputContainer.Explain>
						{message === undefined ? (
							<S.Text>
								<Typography type="label-medium" color="font-tertiary">
									한글, 영문 대소문자, 숫자, 특수문자 밑줄(_), 마침표(.)를
									포함하여 2~15자를 지원합니다.
								</Typography>
							</S.Text>
						) : (
							<Typography type="label-medium" color="orange-primary">
								{parsedMessage}
							</Typography>
						)}
					</InputContainer.Explain>
				</InputContainer.Container>
			</S.TermsSlide>

			<S.BottomButtonContainer>
				<Button
					bgColor={inputNickname.length < 2 ? 'warmgray-300' : 'orange-primary'}
					fullWidth
					disabled={inputNickname.length < 2}
					onClick={() => {
						if (inputNickname.length < 2) {
							setMessage('2글자 이상을 입력해주세요.');
						} else {
							userApi
								.checkNickname(inputNickname)
								.then(() => {
									setResultDataNickname(inputNickname);
									// setSearchParams({ nickname: inputNickname });
									onNext();
								})
								.catch(({ response: { data } }) => {
									setMessage(data.message);
								});
						}
					}}
				>
					<Typography type="title-large" color="white-primary">
						다음
					</Typography>
				</Button>
			</S.BottomButtonContainer>
		</S.SlideContainer>
	);
}
